export default __webpack_public_path__ + "static/media/outro-img.03a01b5e.svg";